import userDetail from "Stores/userDetail";
import { linkedInCookiesState } from "../Stores/LinkedInCookies";
import { URLS, makeApi } from "./apiURL";

let count = 0;
let isContentScriptResponed = false;

// Check Plugin Install by posting msg
export const validatePluginInstalled = () => {
  window.top.postMessage(
    { data: "message", type: "IS_PLUGIN_INSTALLED" },
    "*"
  );
};

// Set Interval to check plugin installed
const intervalId = setInterval(() => {
  count++;
  if (count >= 4 || isContentScriptResponed) {
    clearInterval(intervalId);
    return;
  }
  validatePluginInstalled();
}, 2000);

// Check Plugin Install by receiving msg
const webMessageReceiver = event => {
  if (event?.data?.type) {
    const { type = "" } = event.data;
    switch (type) {
      case "AE_PLUGIN_INSTALLED":
        isContentScriptResponed = true;
        userDetail.setPluginInstalled(true);
        break;
      case "LINKEDIN_CONNECT_PLUGIN_INSTALLED":
        isContentScriptResponed = true;
        userDetail.setLinkedInConnectPluginInstalled(true);
        break;
      default:
        break;
    }
  }
};

// SG-2190: relays a background-detected LinkedIn cookie refresh/logout
// (queued by the extension's service worker while this tab wasn't open,
// see web-main.js) to the backend using this page's own authenticated
// session - the extension has no auth token of its own.
const handlePendingLiSync = async pending => {
  const { type = "", value = null } = pending || {};
  try {
    if (type === "COOKIE_REFRESHED" && value) {
      await makeApi({
        url: URLS.refreshLinkedInCookie,
        method: "POST",
        data: {
          licookie: value,
          userAgent: navigator?.userAgent || ""
        }
      });
    } else if (type === "LOGOUT_DETECTED") {
      await makeApi({
        url: URLS.linkedInLogoutDetected,
        method: "POST",
        data: {}
      });
    }
  } catch (e) {
    console.error("Salesgear: failed to relay pending LinkedIn sync", e);
  }
};

const webMessageReceiverForLinkedIn = event => {
  if (event?.data?.type) {
    const { type = "" } = event.data;
    switch (type) {
      case "LINKEDIN_COOKIES_AT_PLUGIN":
        linkedInCookiesState.setCookieLiAt(event?.data?.data);
        break;
      case "LINKEDIN_COOKIES_A_PLUGIN":
        linkedInCookiesState.setCookieLiA(event?.data?.data);
        linkedInCookiesState.setIsPremiumAccount(true);
        break;
      case "LINKEDIN_PROFILE_DATA_PLUGIN":
        linkedInCookiesState.setProfileData(event?.data?.data);
        break;
      case "LINKEDIN_PENDING_SYNC_PLUGIN":
        handlePendingLiSync(event?.data?.data);
        break;
      default:
        break;
    }
  }
};

window.addEventListener("message", webMessageReceiver, false);
window.addEventListener("message", webMessageReceiverForLinkedIn, false);
